const STEPS = [[5, "things you can see", "👀"], [4, "things you can touch", "✋"], [3, "things you can hear", "👂"], [2, "things you can smell", "👃"], [1, "thing you can taste", "👅"]];
export const GROUND_TOTAL = 15;

// 5-4-3-2-1 grounding: tap once for each thing you notice
export const Grounding = ({ taps, onTap }) => {
  let left = taps, i = 0;
  while (i < STEPS.length && left >= STEPS[i][0]) { left -= STEPS[i][0]; i += 1; }
  if (i >= STEPS.length) return <p className="text-center text-lg font-semibold" data-testid="calm-ground-done">Lovely. You're here, right now. 🌿</p>;
  const [n, label, emoji] = STEPS[i];
  return (
    <div className="flex flex-col items-center text-center" data-testid="calm-ground">
      <div className="text-5xl" aria-hidden>{emoji}</div>
      <p className="text-xl font-bold mt-3" aria-live="polite" data-testid="calm-ground-cue">Notice {n} {label}</p>
      <div className="flex gap-2 mt-4" aria-hidden>{Array.from({ length: n }, (_, k) => <span key={k} className={`w-3 h-3 rounded-full transition-colors ${k < left ? "bg-mm-primary" : "bg-mm-primary/20"}`} />)}</div>
      <button onClick={onTap} className="mm-btn mt-5" data-testid="calm-ground-tap">I noticed one ({left + 1} of {n})</button>
    </div>
  );
};
